import { render } from "./SeolqiCbctV3.vue?vue&type=template&id=877b2366&scoped=true"
import script from "./SeolqiCbctV3.vue?vue&type=script&lang=js"
export * from "./SeolqiCbctV3.vue?vue&type=script&lang=js"

import "./SeolqiCbctV3.vue?vue&type=style&index=0&id=877b2366&scoped=true&lang=css"
import "./SeolqiCbctV3.vue?vue&type=style&index=1&id=877b2366&scoped=true&lang=scss"

import exportComponent from "../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-877b2366"]])

export default __exports__